import React from 'react'

const Poem = () => {
  return (
	<div>
	  		<div className="bg-background3 bg-no-repeat bg-cover bg-bottom bg-fixed">
			<div className="py-20 md:py-52 px-2 flex justify-evenly">
					<div className="text-sm sm:text-xl md:text-3xl lg:text-4xl">
						<p>
						
In the magical world of Leapin' Frogs,<br/>
There's a curious creature, hopping logs.<br/>
With a leather backpack on his back,<br/>
This intrepid frog is always on the attack.<br/>
<br/>
In 101 moments, we see his life unfold,<br/>
A story of adventure, waiting to be told.<br/>
He walks through cities, with towering walls,<br/>
And wanders through woods, where the sunlight falls.<br/>
<br/>
He crosses oceans, where the sea wind blows,<br/>
And explores deserts, where the hot sand glows.<br/>
No path is too treacherous, no place too far,<br/>
He's fearless and bold, like a shining star.<br/>
<br/>
The frog has no name, but his spirit is free,<br/>
A traveler at heart, like you and me.<br/>
We wonder where he is now, and what he might see,<br/>
As he leaps through life, with joyful glee.<br/>
<br/>
He roams through the countryside, with his pack on his back,<br/>
Through meadows and fields, where the wildflowers stack.<br/>
He climbs up mountains, with snow on the peaks,<br/>
And walks through valleys, where the river runs and speaks.<br/>
<br/>
He loves the moments, when the sun sets in the sky,<br/>
And paints the world, with colors that make us sigh.<br/>
He feels the raindrops, as they touch his skin,<br/>
And marvels at the world, that we all live in.<br/>
<br/>
Through all his travels, he seeks the simple joys,<br/>
The wonders that surround us, in life's many alloys.<br/>
He takes in the beauty, of every place he goes,<br/>
And finds the happiness, in the things that most don't know.<br/>
<br/>
So come and join the Leapin' Frogs adventure,<br/>
In a world where pixels, come alive with texture.<br/>
A collection of memories, capturing the frog's essence,<br/>
And all the wonder, of his daring presence.<br/>
</p>
					</div>
			</div>
		</div>
	</div>
  )
}

export default Poem
